import { render, staticRenderFns } from "./AdminAssignedJobs.vue?vue&type=template&id=b2445524&scoped=true"
import script from "./AdminAssignedJobs.vue?vue&type=script&lang=js"
export * from "./AdminAssignedJobs.vue?vue&type=script&lang=js"
import style0 from "./AdminAssignedJobs.vue?vue&type=style&index=0&id=b2445524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2445524",
  null
  
)

export default component.exports